/**
 * Where a Continue watching card opens, and how much is left.
 *
 * Kept out of the component file so that file exports only a component, which React Fast
 * Refresh needs.
 */

/**
 * The page that plays a title - the same routes the rest of the site uses.
 *
 * LIVE_VIDEO is the one that differs, and it is easy to get wrong because the names are
 * so close. Live-video CONTENT is a recorded video played on /live-video/:slug and looked
 * up by slug. /live/:slug is the LIVE STREAM page, a different product entirely. An
 * earlier version sent live-video content to /live/<content id>: the live stream page,
 * handed a content id where a stream slug belongs, which renders nothing useful.
 *
 * Falls back to the general player when a live video somehow has no slug, since that
 * player can load it by id, rather than building a /live-video/ URL that cannot resolve.
 */
export function routeFor(contentType: string, id: string, slug?: string | null): string {
  switch (contentType?.toUpperCase()) {
    case 'CINEMA': return `/media/cinema/${id}`;
    case 'CONTENT': return `/media/contents/${id}`;
    case 'PODCAST': return `/podcasts/${id}`;
    case 'ANIMATION': return `/animations/${id}`;
    case 'SNEAK_PEEK': return `/sneak-peeks/${id}`;
    case 'LIVE_VIDEO': return slug ? `/live-video/${slug}` : `/media/contents/${id}`;
    default: return `/media/contents/${id}`;
  }
}

/** "1h 12m left", "8m left", "Almost done". */
export function timeLeft(positionSeconds: number, durationSeconds: number): string {
  const remaining = Math.max(0, durationSeconds - positionSeconds);
  if (remaining < 60) return 'Almost done';
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  return hours > 0 ? `${hours}h ${minutes}m left` : `${minutes}m left`;
}
